import { render, staticRenderFns } from "./nav-link-button.vue?vue&type=template&id=b3d16cc6&scoped=true"
import script from "./nav-link-button.vue?vue&type=script&lang=js"
export * from "./nav-link-button.vue?vue&type=script&lang=js"
import style0 from "./nav-link-button.vue?vue&type=style&index=0&id=b3d16cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d16cc6",
  null
  
)

export default component.exports